/**
 * Emits schema.org JSON-LD into the rendered markup.
 *
 * Docs routes are prerendered (scripts/prerender.mjs), so this lands in the
 * served HTML and is visible to crawlers that never execute JavaScript.
 *
 * The payload is built from authored page data, never from user input, and
 * `<` is escaped so a string in the content can't terminate the script tag.
 */
export function JsonLd({ data }: { data: readonly Record<string, unknown>[] }) {
  if (data.length === 0) return null;
  return (
    <>
      {data.map((entry) => (
        <script
          key={`${entry["@type"]}:${entry["@id"] ?? ""}`}
          type="application/ld+json"
          // biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD has no other injection point; payload is authored data with `<` escaped
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(entry).replace(/</g, "\\u003c"),
          }}
        />
      ))}
    </>
  );
}
